import * as THREE from 'three';
import type { System } from '../../systems';
import { setAsteroidCameraPosition } from './Asteroid';

/** Publishes the camera's world position to the asteroid module so each
 *  Asteroid.update can do its own distance-based LOD without the entity
 *  needing a camera reference. Runs in systems.update — i.e. *before*
 *  entities.update — so the value is ready when asteroids tick. */
export class AsteroidLodSystem implements System {
  readonly id = 'asteroid-lod';

  private readonly cameraWorld = new THREE.Vector3();

  constructor(private readonly camera: THREE.Camera) {}

  update(_dt: number): void {
    this.camera.getWorldPosition(this.cameraWorld);
    setAsteroidCameraPosition(this.cameraWorld);
  }

  dispose(): void {
    setAsteroidCameraPosition(null);
  }
}
